import { observer } from 'mobx-react-lite';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from 'Hooks/use-window-size';
import { useJobApplicants } from './job-applicants-provider';
import Swal from 'sweetalert2';
import axios from 'axios';
import BaseApi from 'Components/api/BaseApi';
import ApiKey from 'Components/api/ApiKey';
import Cookies from 'js-cookie';
import { logOutIfTokenExpired, resultInfo } from 'Components/helpers';

export function JobApplicantsNavView() {
   const { t } = useTranslation('global');
   const { width } = useWindowSize();
   const jobApplicants = useJobApplicants();
   const tokenKey = Cookies.get('tokenClient');
   const navigate = useNavigate();

   const handleDelete = async (slug?: string) => {
      if (!slug) {
         return;
      }
      try {
         const confirmationResult = await Swal.fire({
            icon: 'question',
            showCancelButton: true,
            cancelButtonText: t('employerInnerAccountdetail.no'),
            confirmButtonText: t('employerInnerAccountdetail.yes'),
            text: t('employerInnerAccountdetail.deleteJobConfirmTxt'),
            title: t('employerInnerAccountdetail.deleteJobConfirmTitle'),
         });

         if (confirmationResult.isConfirmed) {
            const response = await axios.post(BaseApi + `/job/delete/${slug}`, null, {
               headers: {
                  key: ApiKey,
                  token: tokenKey,
                  contentType: 'application/json',
               },
            });

            if (response.data.status === 200) {
               navigate('/user/managejob');

               resultInfo(
                  'success',
                  t('employerInnerAccountdetail.deleteJobSuccessTitle'),
                  t('employerInnerAccountdetail.close')
               ); // eslint-disable-line
            } else if (response.data.status === 400) {
               navigate('/');

               Cookies.remove('fname');
               Cookies.remove('user_id');
               Cookies.remove('user_type');
               Cookies.remove('tokenClient');

               resultInfo('warning', response.data.message, t('employerInnerAccountdetail.close'));
            } else {
               Swal.fire({
                  icon: 'error',
                  text: response.data.message,
                  confirmButtonText: t('employerInnerAccountdetail.close'),
                  title: t('employerFavouriteListProfile.addFavFailedTitle'),
               });
            }
         }
      } catch (error: unknown) {
         if (
            (error instanceof Error && error.message === 'Network Error')
         ) {
            navigate('/');

            logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
         } else {
            resultInfo(
               'error',
               t('employerInnerAccountdetail.deleteJobFailedTitle'),
               t('employerInnerAccountdetail.close')
            ); // eslint-disable-line
         }

         console.error('Could not delete the user in inner account detail page', error);
      }
   };

   return (
      <div className="JobseekerProfileTopBx">
         <h3>
            <span>{jobApplicants.jobInfo?.title}</span>
         </h3>
         <span className="EditJobseekerProfileTag">
            <Link to={`/job/edit/${jobApplicants.jobInfo?.slug}`}>
               <i className="fa fa-pencil" aria-hidden="true"></i>{' '}
               {width >= 768 && t('employerInnerAccountdetail.edit')}
            </Link>
            <Link to={`/user/copy-job/${jobApplicants.jobInfo?.slug}`}>
               <i className="fa fa-file-o" aria-hidden="true"></i>{' '}
               {width >= 768 && t('employerInnerAccountdetail.copy')}
            </Link>
            <Link
               to={`/jobdescription/${jobApplicants.jobInfo?.slug}/${jobApplicants.jobInfo?.cat_slug}`}
            >
               <i className="fa fa-eye" aria-hidden="true"></i>{' '}
               {width >= 768 && t('employerInnerAccountdetail.view')}
            </Link>

            <button disabled onClick={() => handleDelete(jobApplicants.jobInfo?.slug)}>
               <i className="fa fa-trash" aria-hidden="true"></i>{' '}
               {width >= 768 && t('employerInnerAccountdetail.archivate')}
            </button>
         </span>
      </div>
   );
}

export const JobApplicantsNav = observer(JobApplicantsNavView);
